import React, { Fragment } from 'react'
import TimeCounter from './../../../../commons/components/Award/TimeCounter'
import { priceFormat } from '../../../../utils/helpers'

// filter: {value: 1, title: '순위 순'}

const VoteFilter = ({filters = [], active = {}, onSelectFilter}) => {
  return (
    <div className="search-voting__filter-status">
      {filters.map((filter, key) => (
        <button
          key={key}
          className={`btn${filter.value === active.value ? ' active' : ''}`}
          onClick={() => onSelectFilter(filter)}>
          {filter.title}
        </button>
      ))}
      {/*<button className="btn active">순위 순</button>
      <button className="btn ">최신 순</button>
      <button className="btn ">가나다 순</button>*/}
    </div>
  )
}

export default VoteFilter;
